import React from 'react'
import { useTranslation } from 'react-i18next'
import DropDown from '../../../../../component/formFields/DropDown'
import InputField from '../../../../../component/formFields/InputField'
import { GetAccredationsLookup } from '../../../../../api/endpoints/Accredations'
import SectionCard from '../shared/SectionCard'
import './style.css'

const EditAccreditations = ({ formHandler, providerInfo , isLoading }) => {
    const { t } = useTranslation()

    return (
        <SectionCard 
            title={t("accreditations-services")} 
            icon="mdi:certificate"
            className="edit-accreditations"
        >
            <div className="edit-form-grid">
                <DropDown 
                    isLoading={isLoading}
                    label={"accredationIds"} 
                    endPoint={GetAccredationsLookup} 
                    defaultValue={providerInfo?.accredations} 
                    formHandler={formHandler}
                />

                <InputField 
                    isLoading={isLoading}
                    formHandler={formHandler} 
                    name={"accredationOtherName"} 
                    defaultValue={providerInfo?.accredationOtherName}
                    isRequired={false}
                />
            </div>
        </SectionCard>
    )
}

export default EditAccreditations

